<script setup>
import DeleteAction from '@js/components/actions/DeleteAction.vue';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import DialogDrawer from '@js/components/dialogs/DialogDrawer.vue';
import EditorField from '@js/components/fields/EditorField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const { callbackRequest, callback } = defineProps({
    callbackRequest: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const isSubmitting = ref(false);

const isOpen = ref(false);

const form = reactive({
    comment: callbackRequest.comment,
});

const validationSchema = object({
    comment: string().nullable(),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route('front.postCallbackRequest', {
                callbackRequest: callbackRequest.id,
            }),
            {
                comment: form.comment,
            },
        )
        .then((response) => {
            isOpen.value = false;

            if (callback) {
                callback();
            }

            form.comment = response.data.internalComment;
        })
        .finally(() => {
            isSubmitting.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <DialogDrawer v-model="isOpen" size="extra-large">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title> Mettre à jour </template>

        <template #full-content>
            <FormRoot
                :validation-schema="validationSchema"
                :submit="submit"
                v-slot="{ errors }"
            >
                <FormColumn>
                    <FormContent>
                        <EditorField
                            v-model="form.comment"
                            label="Commentaire"
                            placeholder="Commentaire"
                            field-name="comment"
                            field-id="comment"
                        />
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    without-back-button
                >
                    <template #actions>
                        <DeleteAction
                            :url="
                                route('front.deleteCallbackRequest', {
                                    callbackRequest: callbackRequest.id,
                                })
                            "
                            :callback="callback"
                        >
                            <template #trigger>
                                <ActionButton type="danger">
                                    Supprimer
                                </ActionButton>
                            </template>
                        </DeleteAction>
                    </template>
                </FormFooter>
            </FormRoot>
        </template>
    </DialogDrawer>
</template>
